import React, { Component, Fragment } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import 'moment-timezone';
import IndividualForm from './IndividualForm';
import AccountForm from './AccountForm';
import './App.css';
import centroLogo from "./img/centro.png";
import pqLogo from "./img/pq_logo.png";
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';

export default class App extends Component {

  constructor(props){
    super(props);
    this.env = process.env.REACT_APP_ENVIRONMENT;
    this.isProd = this.env === "PROD";
    this.pickMulti = React.createRef();
    this.setOutcome = this.setOutcome.bind(this);
    this.handlePayment = this.handlePayment.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.changePass = this.changePass.bind(this);
    this.urlParams = new URLSearchParams(window.location.search);
    this.incrementMinMonthList = [5832, 5846];
    this.monthPickerLimitMin = {year: parseInt(moment().format('YYYY')), month: parseInt(moment().format('M'))};
    this.monthPickerLimitMax = {year: parseInt(moment().add(11, 'months').format('YYYY')), month: parseInt(moment().add(11, 'months').format('M'))};
    let validity = this.monthPickerLimitMin;
    this.env = process.env.REACT_APP_ENVIRONMENT ? process.env.REACT_APP_ENVIRONMENT.toLowerCase() : '';
    this.baseUrl = process.env.REACT_APP_API_URL;
    this.stripeKey = process.env.REACT_APP_STRIPE_KEY;
    this.activateSuiteForLot = [5741, 5751]; 
    this.state = {
      subscriptionType: 'individual',
      passesScreenActive: true,
      fields: {
        areaCode: 1,
        areaCode2: 1,
        email: ''
      },
      userEmail: [{email: ''}],
      vehicleDetail: [{vehicle_no: '', vehicle_type: '', vehicle_make: '', vehicle_model: '' }],
      errors: {},
      arenaId: this.urlParams.get('id'),
      setOpen: false,
      validity,
      no_of_spots: 1,
      no_of_vehicles: 1,
      visible: this.urlParams.get('visible'),
      lotType: "",
      timeZone: "",
    };
  }

  componentDidMount(){
    this.getArena();
    window.addEventListener('click', (e) => {  
      this.handleOutsideClick(e);
    });
  }

  onOpenModal(){
    this.setState({
      setOpen: true
    })
  } 
  onCloseModal(){
    this.setState({
      setOpen: false
    })
  }

  initStripe(){
    this.stripe = window.Stripe(this.stripeKey);
    console.log("===this.stripe===", this.stripe);
    var elements = this.stripe.elements();

      var style = {
        base: {
          iconColor: '#666EE8',
          color: '#000',
          lineHeight: '40px',
          fontSize: '16px',
      
          '::placeholder': {
            color: '#000',
            fontWeight: 300,
            fontSize: '13px'
          },
        },
      };

      this.card = elements.create('card', {style: style, hidePostalCode: false});

      this.card.mount('#card-element');

      this.card.addEventListener('change', function(event) {
        var displayError = document.getElementById('card-errors');
        if (event.error) {
          displayError.textContent = event.error.message;
        } else {
          displayError.textContent = '';
        }
      });
  }

  handleOutsideClick(e){
    let mql = window.matchMedia('(min-width: 1200px)');
    if (!mql.matches && e.target.className != 'mp-btn' && !e.target.classList.contains('rmp-btn') && e.target.className != 'add-delete-icon' && document.querySelector('.monthly-consumer') && !document.querySelector('.monthly-consumer').contains(e.target)){
      this.setState({
        passesScreenActive: true,
        selectedPass: ''
      })
    }
  }

  refreshAfterSleep(){
		var SAMPLE_RATE = 5000; 
		var lastSample = Date.now();
	  
		function refresh() {
		  if (Date.now() - lastSample >= SAMPLE_RATE * 2) {
			window.location.reload();
		  }
		  lastSample = Date.now();
		  setTimeout(refresh, SAMPLE_RATE);
		}
		refresh();
  }

  manageBodyBackground(isShow){
    if(isShow){
      document.querySelector('#root').classList.add('dark');
    }else{
      document.querySelector('#root').classList.remove('dark');
    }
  }

  handleFocus(name){
    document.querySelector(`input[name="${name}"]`).focus();
    return false;
  }

  getArena(){
    const urlParams = new URLSearchParams(window.location.search);
    fetch(`${this.baseUrl}/parking/arena/details?arena_hash=${urlParams.get('id')}`)
        .then(response => response.json())
        .then(resp => {
          if(resp.data && resp.status === "SUCCESS"){
            const data = resp.data;
            const is45SECase = data.id === 5832;
            const is207CollegeSt = data.id === 5999;
            const is700BiscayneLot = data.id === 6029;
            let showTemplate = urlParams.get('pricing_type');
            showTemplate = is45SECase && showTemplate == "city_national_bank" ? false : showTemplate;
            this.setState({ 
              timeZone: data.timezone,
              parkingId: data.id,
              is45SECase,
              showTemplate,
              name: data.name,
              isShowSuite: this.activateSuiteForLot.includes(data.id),
              validity: this.state.validity,
              lotType: data.lot_types,
              isEnforcement: data.enforcement_enabled,
              is700BiscayneLot,
              is207CollegeSt
              // validity: this.incrementMinMonthList.includes(data.id) ? {year: parseInt(moment().format('YYYY')), month: 6}  : this.state.validity
            }, () => {
              this.getMonthlyPass(data.id);
            })
          }else{
            let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
            toast.error(errMsg);
          }
        })
        .catch((error) => {
            toast.error('Something went wrong');
        });
  }

  getArenaPasses(){
    let list = this.state.passList;
    list = list && list.length ? list.filter(item => item.status === 'active') : [];
    const noPlansStr = "Monthly Plans are currently not available at this parking lot";
    if(!list || !list.length) return <h4 style={{textAlign: 'center', marginTop: '50px'}}>{noPlansStr}</h4>;
    const passes = list.map(item => {
      const detail = item.pricing_data;
      const timeStr = this.getTimeForTimePeriod(detail.time_period);
      const dayType = this.getDayForFrequency(detail.frequency);
      const is207CollegeStVentureXPlan = this.state.is207CollegeSt && item.pricing_type === "VentureX";
      return(
        <div className='monthly-pass'>
          {is207CollegeStVentureXPlan ? <>
            <h3 style={{textTransform: 'capitalize'}}>{item.pricing_type}</h3>
            <h5>Only Weekdays (7AM to 5PM)</h5>
            <h5 style={{marginTop: '15px'}}>Excluding Holidays & Events</h5>
          </> :
          this.state.is700BiscayneLot ? <>
            <h3 style={{textTransform: 'capitalize'}}>{item.pricing_type}</h3>
            <h5>Weekdays (9AM to 5PM)</h5>
            <h5 style={{marginTop: '15px'}}>No Access: Events & Weekends</h5>
          </> : 
          <>
            <h3 style={{textTransform: 'capitalize'}}>{item.pricing_type}</h3>
            <h5 style={{textTransform: 'capitalize'}}>{detail.time_period ? detail.time_period.replace('_', ' ') : ''}</h5>
            <h5>{timeStr}</h5>
            <h5 style={{marginTop: 12}}>{dayType}</h5>
            {detail.frequency === 'all_days' && detail.time_period === 'full_day' && <h5 style={{marginTop: 12}}>{this.state.is45SECase && item.pricing_type === 'Corporate Rate' ? 'For 6 or more cars' : this.state.is45SECase ? '' : <>In & Out Privileges <span style={{color: '#cc0000'}}>*</span></>}</h5>}
          </>}
          
          <h2>${detail.rental_fee >= 0 ? detail.rental_fee/100 : ''}</h2>
          {this.state.parkingId == 6029 && detail.rental_fee ==18458 && <h6 style={{fontWeight: 500}}>($150 + Taxes)</h6>} 
          <h6>per user</h6>
          {this.state.subscriptionType === 'account' && detail.discount && detail.discount.length > 0 && <div>
              <table>
                  <thead>
                    <th style={{fontSize: '12px'}} colSpan={3}>No. Of Users</th>
                    <th></th>
                    <th style={{fontSize: '12px'}}>Discount</th>
                  </thead>
                  <tbody className="bucket-input">
                      {this.getDiscountContent(detail.discount)}
                  </tbody>
              </table>
          </div>}
          <button className='mp-btn' onClick={() => this.handlePassSelection(item)}>Select</button>
        </div>
      )
    })
    return passes;
  }

  getTimeForTimePeriod(data){
    let time  = '';
    switch (data) {
      case "regular_hours":
        time = '(9am to 5pm)';
        break;
      case "after_hours":
        time = '(5pm to 9pm)';
        break;
      case "full_day":
        time = '(24 hours)';
        break;  
      default:
        break;
    }
    return time;
  }

  getDayForFrequency(data){
    let freq  = '';
    switch (data) {
      case "weekdays":
        freq = 'Weekdays (Mon-Thu)';
        break;
      case "weekends":
        freq = 'Weekends (Thu-Sun)';
        break;
      case "all_days":
        freq = 'All Days';
        break;
      case "1":
        freq = '1 Day Per Week';
        break;
      case "2":
        freq = '2 Days Per Week';
        break; 
      case "3":
        freq = '3 Days Per Week';
        break;
      case "4":
        freq = '4 Days Per Week';
        break;
      case "5":
        freq = '5 Days Per Week';
        break;
      case "6":
        freq = '6 Days Per Week'; 
        break;
      case "7":
        freq = '7 Days Per Week';
        break;      
      default:
        break;
    }
    return freq;
}

  getDiscountContent(saved){
    const list = saved ? saved : [];
    return list.map((item, index) => {
        
        const major = (<tr>
            
            <td>
              <center>
                <div className='discount-data'>{item.start ? item.start : ''}</div>
              </center>
            </td>
            <td style={{fontSize: '12px'}}>&nbsp;to&nbsp;</td>
            <td>
              <center>
                <div className='discount-data'>{item.end ? item.end : ''}</div>
              </center>
            </td>
            <td>
              &nbsp;&nbsp;
            </td>
            <td>
              <center style={{ width: '80px' }}>
                  <div className='discount-data'>{item.value ? item.value + '%' : ''}</div>
              </center>
            </td>
            
          </tr>);
          
      
        return major;
      
    })
  }

  calculateAccountPrice(){
    let params = '';
    let { fields, selectedPass } = this.state; 
    if(fields.reserve_spot == 'true' && selectedPass && selectedPass.pricing_data && selectedPass.pricing_data.is_reserve_spot){
      params = `parking_id=${this.state.parkingId}&slot_count=${this.state.no_of_spots}&pass_type=${this.state.selectedPass ? this.state.selectedPass.pricing_type : ''}&reserve_spot=true`;
    }else{
      params = `parking_id=${this.state.parkingId}&slot_count=${this.state.no_of_spots}&pass_type=${this.state.selectedPass ? this.state.selectedPass.pricing_type : ''}&reserve_spot=false`;
    }
    fetch(`${this.baseUrl}/parking/monthly/bulk/pricing?${params}`)
        .then(response => response.json())
        .then(resp => {
          if(resp.data && resp.status === "SUCCESS"){
            this.setState({ 
              monthlyAccountPrice: resp.data.rental_amount/100,
              rentalFee: resp.data.rental_fee,
              convFee: resp.data.conv_fee,
              reservedSpot: resp.data.reserved_spot,
              isPayment: this.urlParams.get('pay') === "true" && this.state.subscriptionType === 'individual' ? true : this.state.subscriptionType === 'individual' && resp.data.is_payment ? true : false,
              terms: resp.data.terms ? resp.data.terms : []
            }, () => {
              const defer = () =>  {
                if (window.Stripe && this.state.isPayment) {
                    this.initStripe(this);
                } else {
                    setTimeout(function() { defer ()  }, 50);
                }
              }
              defer();
            })
          }else{
            let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
            toast.error(errMsg);
          }
        })
        .catch((error) => {
            toast.error('Something went wrong');
        });
  }

  filterBasedOnSubscriptionType(originalPassList, isUpdateState){
    let passList = [];
    let subscriptionType = this.state.subscriptionType;
    if(subscriptionType == "account"){
      passList = originalPassList.filter(item => item.pricing_data.is_account);
    }else if(subscriptionType == "individual"){
      passList = originalPassList.filter(item => item.pricing_data.is_individual);
    }
    if(isUpdateState){
      this.setState({
        passList
      })
    }else{
      if(originalPassList?.length && !passList?.length){
        passList = originalPassList.filter(item => item.pricing_data.is_account);
        subscriptionType = "account";
      }
      return { passList, subscriptionType };
    }
  }

  getMonthlyPass(id){
    fetch(`${this.baseUrl}/parking/monthly/pricing/list?parking_id=${id}`)
        .then(response => response.json())
        .then(resp => {
          if(resp.data && resp.status === "SUCCESS"){
            let respPricingCopy = resp.data.pricing && resp.data.pricing.length ? JSON.parse(JSON.stringify(resp.data.pricing)) : [];
            /* if(this.state.is45SECase){
              respPricingCopy.forEach(obj => {
                if(obj.pricing_data)
                obj.pricing_data.visible = obj.pricing_type === "General Rate" || obj.pricing_type === "Corporate Rate" ? true : false; 
              })
             }*/
            if(this.state.showTemplate){
              let templateName = this.state.showTemplate.replaceAll('_', ' ').toLowerCase();
              respPricingCopy.forEach(obj => {
                if(obj.pricing_data)
                obj.pricing_data.visible = obj.pricing_type && obj.pricing_type.toLowerCase() === templateName  ? true : false; 
              })
            }
            const originalPassList = !resp.data.new_subscription_allowed ? [] : respPricingCopy && respPricingCopy.length ?
                                        this.state.visible !== "false" ?
                                        respPricingCopy.filter(item => item.pricing_data && (!item.pricing_data.hasOwnProperty('visible') || item.pricing_data.visible)) 
                                        : respPricingCopy.filter(item => item.pricing_data && item.pricing_data.visible === false) 
                                        : [];
            const isIndividualCount = originalPassList.some(item => item.pricing_data.is_individual);
            const isAccountCount = originalPassList.some(item => item.pricing_data.is_account);
            const filterObj = this.filterBasedOnSubscriptionType(originalPassList);
            this.setState({ 
              isAutoApproval: resp.data.request_auto_approved,
              passFetched: true,
              originalPassList,
              passList: filterObj.passList,
              subscriptionType: filterObj.subscriptionType,
              isIndividualCount,
              isAccountCount
            }) 
          }else{
            let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
            toast.error(errMsg);
          }
        })
        .catch((error) => {
          toast.error('Something went wrong');
        });
  }
  
  handlePayment(e){
    e.preventDefault();
    document.getElementById("pay-submit").disabled =  true;
    if(this.state.loading) return;
    const submitBtn = document.getElementById("pay-submit");
    const isValid = this.validateForm();
    if(!isValid) {
      submitBtn.disabled = false;
      return;
    }
    /* if(!this.state.totalFee){
      toast.error('Invalid details!');
      submitBtn.disabled = false;
      return;
    }
    if(!this.state.isSaveProfile){
      toast.error('Please accept the terms and conditions');
      submitBtn.disabled = false;
      return;
    } */
    this.manageBodyBackground(true);
    this.setState({loading : true});
    let { fields }  = this.state; 
    var options = {
      statement_descriptor: 'Monthly parking at ' + fields.name,
      owner: {
        name: fields.cardholder_name,
        email: fields.email,
        phone: "+" + fields.areaCode + ' ' + fields.phone1
      }
    };
    if(this.stripe) this.stripe.createSource(this.card, options).then(this.setOutcome, this);
  }

  setOutcome(result) {
    const submitBtn = document.getElementById("pay-submit");
    if (result.source && result.source.id) {
      this.handleSubmit(null, result.source.id, this.card);
    } else if (result.error) {
      this.manageBodyBackground(false);
      this.setState({loading : false});
      toast.error(result.error.message ? result.error.message : 'Something went wrong', { autoClose: 10000 });
      submitBtn.disabled = false;
    }
  }

  addTimestampsToAlternateVehicles(details, type) {
    const currentTime = moment().tz(this.state.timeZone).valueOf();
    if (type === 'individual') {
        return details.map(vehicle => {
            if (vehicle.alternate_vehicles) {
                vehicle.alternate_vehicles = vehicle.alternate_vehicles.map(alternateVehicle => ({
                    ...alternateVehicle,
                    created_at: currentTime,
                    updated_at: currentTime
                }));
            }
            return vehicle;
        });
    } else if (type === 'account') {
      return details.map(user => {
          if (user.alternate_vehicles && user.alternate_vehicles.length > 0) {
              user.alternate_vehicles = user.alternate_vehicles.map(alternateVehicle => ({
              ...alternateVehicle,
              created_at: currentTime,
              updated_at: currentTime
          }));
          }
          return user;
      });
  }
    return details;
}

  handleSubmit(e, id, card, request){
    const submitBtn = document.getElementById("pay-submit");
    submitBtn.disabled = true;
    this.setState({loading : true});

    if (request.type === 'individual') {
      request.vehicle_detail = this.addTimestampsToAlternateVehicles(request.vehicle_detail, 'individual');
    } else if (request.type === 'account') {
      request.users_info = this.addTimestampsToAlternateVehicles(request.users_info, 'account');
    }
    
    if(this.state.isPayment){
      request = {
        ...request,
        source_id: id
      }
    }    
    let istypeAccount = request.type === 'account';
    let isAccountAndPayByIndividual = istypeAccount && request.payment_type === "individual";
    fetch(istypeAccount ? `${this.baseUrl}/parking/monthly/account/request` : `${this.baseUrl}/parking/monthly/user/request`, {
      method: 'post',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify(request)
     })
      .then(response => response.json())
      .then(resp => {
        if(resp.status === "SUCCESS" && resp.data){
          window.scrollTo(0,0);
          this.setState({fields: {cardholder_name: '', areaCode: 1}}, () => {
            if(card) card.clear();
            if(isAccountAndPayByIndividual){
              this.manageBodyBackground(false);
              this.setState({booked: true, loading: false});
              return;
            }
            if(!this.state.isAutoApproval){
              this.setState({booked: true, loading: false});
              return;
            }
            if(this.env === 'prod'){
              window.location.href = istypeAccount ? `https://monthly.parkquility.com/account?id=${resp.data.account_hash}` : 
                                                      `https://monthly.parkquility.com?id=${resp.data.pass_hash}`;
            }else{
              window.location.href = istypeAccount ? `https://${this.env}monthly.parkquility.com/account?id=${resp.data.account_hash}` : 
                                                      `https://${this.env}monthly.parkquility.com?id=${resp.data.pass_hash}`
            }
          });
        }else{
          let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
          this.manageBodyBackground(false);
          this.setState({loading : false});
          toast.error(errMsg, { autoClose: errMsg.length > 20 ? 10000 : 2000 });
          submitBtn.disabled = false;
        }
      })
      .catch((error) => {
        this.manageBodyBackground(false);
        this.setState({loading : false});
        toast.error('Something went wrong');
        submitBtn.disabled = false;
      });  
  }

  handleSubscriptionType(type){
    this.setState({
      subscriptionType: type
    }, () => this.filterBasedOnSubscriptionType(this.state.originalPassList, true))
  }

  handlePassSelection(item){
    this.setState({
      passesScreenActive: false,
      selectedPass: item
    }, () => this.calculateAccountPrice())
  }

  changePass(){
    this.setState({
      passesScreenActive: true,
      selectedPass: ''
    })
  }

  render() {
    return (
      <div style={{position: 'relative'}}>
        {this.state.isVehicleOnboarded === false &&  <div style={{position: 'absolute', width: '100%', height: '100%', zIndex: 10, backgroundColor: 'rgba(255, 255, 255, 0.90)'}}></div>}
        {this.state.loading &&  <div style={{position: 'absolute', width: '100%', height: '100%', zIndex: 10}}></div>}
        {this.state.loading && <div className="loader">Loading...</div>}
        
        <div style={{display: this.state.booked ? 'block' : 'none'}} className="success-message">
          <svg viewBox="0 0 76 76" className="success-message__icon icon-checkmark">
            <circle cx="38" cy="38" r="36"></circle>
            <path fill="none" stroke="#FFFFFF" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M17.7,40.9l10.9,10.9l28.7-28.7" style={{strokeDashoffset: 0, strokeDasharray: 56.0029}}></path>
          </svg>
          <h3 style={{fontSize: this.state.isAutoApproval ? '1.17em' : '1em'}} className="success-message__title">{!this.state.isAutoApproval ? 'Thanks, the request is under review' : 'Sent Successfully'}</h3>
          <p style={{position: 'relative', top: '28px', fontSize: '12px', color: '#888'}}>(You can close this tab)</p>
        </div>
        <div>
          {this.state.parkingId == 5741 ? <div style={{ paddingTop: 10, paddingBottom: 20, margin: '0 -10px'}}>
            <img style={{height: 45, float: 'left'}} src={pqLogo} />
            <img style={{height: 21, marginTop: 12, float: 'right'}} src={centroLogo} />
            <div style={{clear: 'both'}}></div>
          </div> :
          <div style={{textAlign: 'center', paddingBottom: '20px'}}>
            <img style={{height: 85}} src="https://portal.parkquility.com/public/pq_logo.png" />
          </div>}
          {this.state.passesScreenActive && <div>
            <p style={{textAlign: 'center', color: '#666565'}}>Welcome to {this.state.name} Parking Lot Monthly Parking Page</p>
          </div>}
        </div>
        {this.state.passesScreenActive && this.state.passList && this.state.passList.length > 0 && <div style={{textAlign: 'center', marginTop: '15px'}}>
           <div className='subscription-type' style={{marginBottom: '20px'}}>
            {this.state.isIndividualCount && <button style={{borderTopLeftRadius: '4px', borderBottomLeftRadius: '4px'}} className={this.state.subscriptionType === 'individual' ? 'active' : ''} onClick={() => this.handleSubscriptionType('individual')}>Individual</button>}
            {this.state.isAccountCount && <button style={{borderTopRightRadius: '4px', borderBottomRightRadius: '4px'}} className={this.state.subscriptionType === 'account' ? 'active' : ''} onClick={() => this.handleSubscriptionType('account')}>Account</button>}
          </div>
          <p style={{color: '#666565', marginBottom: '10px', marginTop: this.state.showTemplate ? '20px' : 0}}>Available plans</p>
          {this.getArenaPasses()}
          {this.state.passList && this.state.passList.length > 0 && !this.state.is45SECase && !this.state.is700BiscayneLot && !(this.state.is207CollegeSt && this.state.showTemplate) && <p style={{margin: '50px auto 10px auto', textAlign: 'center'}}><span style={{color: '#cc0000', fontSize: '12px'}}>*</span>In the event of In-and-Out, we do not guarantee a spot</p>}
          {/* this.state.passList && this.state.passList.length > 0 && this.state.is45SECase && <p style={{margin: '10px auto 50px auto', textAlign: 'center', fontWeight: 'bold'}}>We also have special rates for Citi National Bank and Hyatt. If you are an employee, please go to the office to signup for special rates. Overnight 96, after 6 and before 9. Construction is 100. Declined Card - $25</p> */}
        </div>}
        {this.state.passFetched && (!this.state.passList || !this.state.passList.length) && <div>
          <h4 style={{textAlign: 'center', marginTop: '50px'}}>Monthly Plans are currently not available at this parking lot</h4>
        </div>}
        {!this.state.passesScreenActive && !this.state.booked && this.state.subscriptionType === 'individual' &&
          <IndividualForm 
            toast={toast}
            onOpenModal={this.onOpenModal.bind(this)}
            onCloseModal={this.onCloseModal.bind(this)}
            handlePayment={this.handlePayment.bind(this)}
            handleSubmit={this.handleSubmit.bind(this)}
            selectedPass={this.state.selectedPass}
            subscriptionType={this.state.subscriptionType}
            parkingId={this.state.parkingId}
            isPayment={this.state.isPayment}
            calculateAccountPrice={this.calculateAccountPrice.bind(this)}
            changePass={this.changePass.bind(this)}
            lotType={this.state.lotType}
            isEnforcement={this.state.isEnforcement}
            isAutoApproval={this.state.isAutoApproval}
            terms={this.state.terms}
          />}
          {!this.state.passesScreenActive && !this.state.booked && this.state.subscriptionType === 'account' &&
          <AccountForm 
            toast={toast}
            onOpenModal={this.onOpenModal.bind(this)}
            onCloseModal={this.onCloseModal.bind(this)}
            handlePayment={this.handlePayment.bind(this)}
            handleSubmit={this.handleSubmit.bind(this)}
            selectedPass={this.state.selectedPass}
            subscriptionType={this.state.subscriptionType}
            parkingId={this.state.parkingId}
            isPayment={this.state.isPayment}
            calculateAccountPrice={this.calculateAccountPrice.bind(this)}
            changePass={this.changePass.bind(this)}
            lotType={this.state.lotType}
            isEnforcement={this.state.isEnforcement}
            isAutoApproval={this.state.isAutoApproval}
            terms={this.state.terms}
          />}
        <Modal open={this.state.setOpen} onClose={this.onCloseModal.bind(this)} center>
          <h4>Terms and Conditions</h4>
          <ol>
            {this.state.terms && this.state.terms.map(item => {
              return <li style={{fontSize: '12px', marginBottom: '5px'}}>{item}</li>
            })}
          </ol>
        </Modal> 
        <ToastContainer autoClose={2000} closeButton={true} style={{fontSize: 14}}/>
      </div>    
    )
  }
}
